export const channels = [
  {
    id: 'c-01',
    icon: 'ri-movie-2-line',
    name: '娱乐圈内幕',
    count: '186 篇',
    desc: '从选角、宣发到合约结构，逐层拆解台前看不见的决定链路。',
    tags: ['选角流程', '宣发预算', '合约结构'],
  },
  {
    id: 'c-02',
    icon: 'ri-broadcast-line',
    name: '网红圈潜规则',
    count: '142 篇',
    desc: 'MCN孵化、保底协议与流量采买，把直播间之外的那部分写清楚。',
    tags: ['MCN孵化', '保底协议', '流量采买'],
  },
  {
    id: 'c-03',
    icon: 'ri-group-line',
    name: '饭圈操作',
    count: '97 篇',
    desc: '打投、控评与集资流向，观察一套被标准化执行的协作机制。',
    tags: ['打投流水', '控评分工', '集资流向'],
  },
];